import { Injectable, Injector } from '@angular/core';
import {
  InspectionModel,
  InspectionTemplate
} from '@authority-labs/api-interfaces';
import { Path } from '@authority-labs/enums';
import { plainToInstance } from 'class-transformer';
import { Observable } from 'rxjs';
import { CrudService } from '../../shared/services/crud/crud.service';

@Injectable({
  providedIn: 'root'
})
export class InspectionTemplatesService extends CrudService<InspectionTemplate> {
  constructor(injector: Injector) {
    super(injector, Path.InspectionTemplates, InspectionTemplate);
  }

  createOne(
    item: InspectionTemplate,
    queryParams: string = ''
  ): Observable<InspectionTemplate> {
    item.inspection = new InspectionModel(item.inspection);
    return super.createOne(item, queryParams);
  }

  manyPlainToClass(items: InspectionTemplate[]): InspectionTemplate[] {
    return plainToInstance(InspectionTemplate, items.map(this.plainToClass));
  }

  plainToClass = (item: InspectionTemplate): InspectionTemplate => {
    item.inspection = new InspectionModel(item.inspection);
    return item;
  };
}
